import { cn } from "@/lib/utils";

interface NeonLoadingRingProps {
  className?: string;
}

/**
 * A flat, low-cost loading mark shared by startup and onboarding surfaces.
 * The surrounding screen owns the accessible status copy, so the moving ring
 * stays decorative.
 */
export function NeonLoadingRing({ className }: NeonLoadingRingProps) {
  return (
    <div
      data-jp-loading-animation="flat-neon-ring"
      className={cn("relative h-20 w-20", className)}
      aria-hidden="true"
    >
      <div
        data-jp-loading-ring="outer"
        className="absolute inset-0 rounded-full border-4 border-transparent border-r-jp-accent-secondary border-t-jp-accent-primary motion-safe:animate-spin"
      />
      <div
        data-jp-loading-ring="inner"
        className="absolute inset-0 rounded-full border-4 border-transparent border-b-jp-accent-streak border-l-jp-accent-magenta motion-safe:animate-spin"
        style={{ animationDirection: "reverse", animationDuration: "1.5s" }}
      />
    </div>
  );
}
